import React from "react"

class Collection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collection_details_confirmed: false,
      collection_information: {
        engineers_name: props.accountDetails.name || "",
        telephone: props.accountDetails.telephone || props.guestTelephone || "",
        email: props.accountDetails.email || "",
        purchase_order: "",
        instructions: ""
      }
    };
    this.completeCollectionOnlyOrder = this.completeCollectionOnlyOrder.bind(
      this
    );
    this.editThisStep = this.editThisStep.bind(this);
    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleChangeEngineersName = this.handleChangeEngineersName.bind(this);
    this.handleChangeInstructions = this.handleChangeInstructions.bind(this);
    this.handleChangePurchaseOrder = this.handleChangePurchaseOrder.bind(this);
    this.handleChangeTelephone = this.handleChangeTelephone.bind(this);
    this.toggleCollectionDetailsConfirmed = this.toggleCollectionDetailsConfirmed.bind(
      this
    );
    this.updateCollectionInformation = this.updateCollectionInformation.bind(
      this
    );
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.accountDetails.telephone !== this.props.accountDetails.telephone
    ) {
      var newState = this.state.collection_information;
      newState.telephone = nextProps.accountDetails.telephone;
      this.setState({
        collection_information: newState
      });
    }
    if (nextProps.guestTelephone !== this.props.guestTelephone) {
      var newState = this.state.collection_information;
      newState.telephone = nextProps.guestTelephone;
      this.setState({
        collection_information: newState
      });
    }
  }
  toggleCollectionDetailsConfirmed() {
    this.setState({
      collection_details_confirmed: !this.state.collection_details_confirmed
    });
  }
  handleChangeEngineersName(e) {
    var newState = this.state.collection_information;
    newState.engineers_name = e.target.value;
    this.setState({
      collection_information: newState
    });
  }
  handleChangeEmail(e) {
    var newState = this.state.collection_information;
    newState.email = e.target.value;
    this.setState({
      collection_information: newState
    });
  }
  handleChangeInstructions(e) {
    var newState = this.state.collection_information;
    newState.instructions = e.target.value;
    this.setState({
      collection_information: newState
    });
  }
  handleChangeTelephone(e) {
    if (this.props.orderType != "MIXED") {
      var newState = this.state.collection_information;
      newState.telephone = e.target.value;
      this.setState({
        collection_information: newState
      });
    }
  }
  handleChangePurchaseOrder(e) {
    var newState = this.state.collection_information;
    newState.purchase_order = e.target.value;
    this.setState({
      collection_information: newState
    });
  }
  completeCollectionOnlyOrder() {
    this.props.completeCollectionOnlyOrder(
      this.state.collection_information,
      this.state.collection_details_confirmed
    );
  }
  updateCollectionInformation() {
    this.props.setLoadingState(true);
    $.ajax({
      url: this.props.collectionUrl,
      method: "PUT",
      dataType: "json",
      data: {
        collection_information: this.state.collection_information,
        collection_confirmed: this.state.collection_details_confirmed
      },
      success: () => {
        this.props.showDetailErrors(false);
        this.props.setCurrentStep("PAYMENT");
        this.props.setLoadingState(false);
      },
      error: data => {
        // TODO: Global Error
        console.log("There's been an error updating collection information!");
        this.props.showDetailErrors(true, data.responseText);
        this.props.setLoadingState(false);
      }
    });
  }
  editThisStep() {
    // should we do a clear down as we're moving back and get updated delivery options?
    this.props.setCurrentStep("COLLECTION_DETAILS");
  }

  render() {
    var editStep =
      this.props.current_step === "PAYMENT" &&
        this.props.orderType === "MIXED" ? (
          <strong className="pull-right edit" onClick={this.editThisStep}>
            Edit
        </strong>
        ) : (
          ""
        );

    var completedStep =
      this.props.current_step === "PAYMENT" &&
        this.props.orderType === "MIXED" ? (
          <i className="icon-ok" />
        ) : (
          ""
        );
    var nextStep =
      this.props.orderType === "COLLECTION" ? (
        <button
          onClick={this.completeCollectionOnlyOrder}
          disabled={
            this.state.collection_details_confirmed == false ||
            this.state.collection_information.email == ""
          }
        >
          Place Order
        </button>
      ) : (
          <button
            onClick={this.updateCollectionInformation}
            disabled={
              this.state.collection_details_confirmed == false ||
              this.state.collection_information.email == ""
            }
          >
            Continue to Payment
        </button>
        );
    var purchaseOrder =
      this.props.orderType === "COLLECTION" ? (
        <div className="fl-fb-50 collection-phone">
          <label>
            {this.props.signed_in === true
              ? "Purchase Order"
              : "Your Reference"}
          </label>
          <input
            type="text"
            onChange={this.handleChangePurchaseOrder}
            value={this.state.collection_information.purchase_order}
          />
        </div>
      ) : (
          ""
        );

    var showDisplayError = this.props.show_display_error && (
      <div className="showPaymentDisplayError">
        <ul className="errors">
          {this.props.display_errors.map((errorMessage, index) => {
            return <li key={index}>{errorMessage}</li>;
          })}
        </ul>
      </div>
    );
    return (
      <div
        className={
          "checkout-panel collection-details-step " +
          (this.props.current_step === "COLLECTION_DETAILS"
            ? ""
            : "not-active") +
          (this.props.processingState === true ? " processing-payment" : "")
        }
      >
        <div className="checkout-header-title">
          <div className="checkout-header-title-left">
            <strong>{this.props.step}.</strong> Collection Details{" "}
            {completedStep}
          </div>
          <div className="checkout-header-title-right">{editStep}</div>
        </div>

        <div className="checkout-sub-panel">
          <div>
            <strong>{this.props.collectionAddress.name}</strong>
            <br />
            {this.props.collectionAddress.line_1}
            <br />
            {this.props.collectionAddress.line_2}
            <br />
            {this.props.collectionAddress.line_3}
            <br />
            {this.props.collectionAddress.line_4}
            <br />
            {this.props.collectionAddress.line_5}
            <br />
            {this.props.collectionAddress.postcode}
            <hr />
          </div>

          <div className="fl-on fl-jc-sb ">
            {purchaseOrder}
            {this.props.orderType !== "MIXED" && (
              <div className="fl-fb-50 collection-phone">
                <label>
                  Telephone <span className="required">*</span>
                </label>
                <input
                  type="text"
                  onChange={this.handleChangeTelephone}
                  value={this.state.collection_information.telephone}
                />
              </div>
            )}
          </div>
          <p>
            {this.props.signed_in ? (
              <strong>
                Please provide the contact details of the person collecting the goods:
              </strong>
            ) : null}
          </p>
          <div className="fl-on fl-jc-sb person-collecting-details">
            <div className="fl-fb-50">
              {this.props.signed_in ? (
                <label>Engineer's Name </label>
              ) : (
                  <label>Name </label>
                )}
              <input
                type="text"
                onChange={this.handleChangeEngineersName}
                value={this.state.collection_information.engineers_name}
              />
            </div>

            <div className="fl-fb-50">
              <label>
                Email <span className="required">*</span>
              </label>
              <input
                type="text"
                onChange={this.handleChangeEmail}
                value={this.state.collection_information.email}
              />
            </div>
          </div>
          <div className="collection-instructions">
            <label>Instructions </label>
            <textarea
              onChange={this.handleChangeInstructions}
              value={this.state.collection_information.instructions}
            />
          </div>
          <div className="collection-confirmation">
            <div className="collection-notice">
              <input
                type="checkbox"
                checked={this.state.collection_details_confirmed}
                onClick={this.toggleCollectionDetailsConfirmed}
              />
              {this.props.signed_in ? (
                <p onClick={this.toggleCollectionDetailsConfirmed}>
                  I am aware that my click and collect items will be invoiced on
                  my CEF Trade Account or paid for by Debit or Credit Card at
                  the time of collection. Please wait for you order to be
                  confirmed before you leave to collect your goods. You will
                  receive an email when your goods are ready.
                </p>
              ) : (
                  <p onClick={this.toggleCollectionDetailsConfirmed}>
                    I am aware that my click and collect items will be paid for at
                    the time of collection. Please wait for your order to be
                    confirmed before you leave to collect your goods. You will
                    receive an email when your goods are ready.
                </p>
                )}
            </div>
          </div>
          {showDisplayError}
        </div>
        <div className="checkout-sub-panel fl-on fl-sm-on next-step">
          {nextStep}
        </div>
      </div>
    );
  }
}

export default Collection;
